<template>
    <a href="javascript:void(0)" :class="['theme-link', marginClasses, sizeClasses, colorClasses]" :style="colorStyle">
        {{component.value}}
    </a>
</template>

<script>
    export default {
        name: 'LinkRenderer',
        props: ['component', 'layout'],
        computed: {
            marginClasses() {
                if(!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },

            sizeClasses() {
                if(!this.component.style.size) {
                    return ''
                }

                return `${this.component.style.size}`
            },

            colorClasses() {
                if(this.layout.theme_id) {
                    return ''
                }

                if(this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0 ) {
                    return `text-${this.component.style.color}`
                }

                return ''
            },

            colorStyle() {
                if(this.isCustomColor) {
                    return {
                        color: this.component.style.color
                    }
                }

                return ''
            },

            isCustomColor() {
                return webase.utils.ui.isCustomColor( this.component )
            },
        },
        data () {
            return {
                model: webase.model
            }
        },
        methods: {

            // TODO: need a property to make executing a link dynamic

            executeLink () {
                if(this.component.view && this.$router) {
                    this.$router.push({ name: 'view-renderer', params: {id: this.component.view}})
                }
                else if(this.component.resourceType === 'View' && this.component.resource && this.$router) {
                    this.$router.push({ name: 'view-renderer', params: {id: this.component.resource}})
                }
                else if((this.component.resourceType === 'Link' || this.component.resourceType === 'URL') && this.component.resource) {
                    window.open(this.component.resource);
                }
            }
        }
    }
</script>

<style>

</style>
